import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

/** Andamento de uma consulta de pré-preenchimento (união discriminada). */
export type LookupStatus =
  | { kind: 'idle' }
  | { kind: 'loading' }
  | { kind: 'success'; message: string; notices: readonly string[] }
  | { kind: 'error'; message: string };

/** Mensagem do andamento de uma consulta (anunciada a leitores de tela). */
export function LookupStatusMessage({ status }: { status: LookupStatus }): ReactNode {
  const message =
    status.kind === 'idle' ? '' : status.kind === 'loading' ? 'Consultando…' : status.message;
  return (
    <div role="status" aria-live="polite" className="text-sm">
      {message !== '' && (
        <p className={cn(status.kind === 'error' ? 'text-destructive' : 'text-muted-foreground')}>
          {message}
        </p>
      )}
      {status.kind === 'success' &&
        status.notices.map((notice) => (
          <p key={notice} className="font-medium text-amber-700 dark:text-amber-400">
            {notice}
          </p>
        ))}
    </div>
  );
}
